import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { privilegesQueries } from '@/services/rolesPrivilege/privileges.queries';

export const usePrivileges = (roleId: string) => {
  const { data, isLoading } = useQuery({
    ...privilegesQueries.functions(roleId),
  });

  return { privileges: data?.data || [], isLoading };
};
